// Mask an email address so the local part and domain are partially hidden.
// Keeps the first character of the local part and the TLD intact so users
// remain recognizable-to-themselves without exposing the full inbox.
//
// Examples:
//   marco@gmail.com     -> m****@g****.com
//   a@x.io              -> a@x****.io
//   user_1234@t.test    -> u*******@t****.test
export const maskEmail = (email) => {
  if (!email || typeof email !== "string" || !email.includes("@")) return email || "";
  const [local, domain] = email.split("@");
  const maskedLocal = local.length <= 1
    ? local
    : local[0] + "*".repeat(Math.max(3, Math.min(8, local.length - 1)));
  const dotIdx = domain.lastIndexOf(".");
  if (dotIdx <= 0) return `${maskedLocal}@${domain}`;
  const head = domain.slice(0, dotIdx);
  const tld = domain.slice(dotIdx); // includes leading "."
  const maskedHead = head.length <= 1
    ? head
    : head[0] + "*".repeat(Math.max(3, Math.min(6, head.length - 1)));
  return `${maskedLocal}@${maskedHead}${tld}`;
};
